module.exports = __webpack_public_path__ + "static/media/logo-dark2.b49acee3.png";